import Axios from 'axios'

const traceabilityStatisticsService = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.TRACEABILITY_BASE_URL
    return AxiosInstance
  },
  getTraceabilityTotalStatus(filters = {}) {
    return this.axios().get('/exams/indicators', { params: filters })
  },
  getTraceabilityTotalDelayedExamsCount(filters = {}) {
    return this.axios().get('exams/delay/count', { params: filters })
  },
  getTotalSamplesGoingToPlaceExecution() {
    return this.axios().get('/exams/destiny/count')
  },
}

export default traceabilityStatisticsService
